import { isAxiosError } from "axios";
import {
    MAIL_ATTACHMENTS_TOO_LARGE_CODE,
    type CartSubmitAttachmentsTooLargeResponse
} from "@/api/modules/autoQ/checkout/types.ts";

const HTTP_UNPROCESSABLE_ENTITY = 422;

// cart/submit also answers 422 for other reasons (e.g. an invalid quality statement), so only the error code
// identifies a cart whose documents are too large for one mail.
export const extractAttachmentsTooLargeError = (error: unknown): CartSubmitAttachmentsTooLargeResponse | null => {
    if (!isAxiosError(error) || error.response?.status !== HTTP_UNPROCESSABLE_ENTITY) {
        return null;
    }

    const body = error.response.data as Partial<CartSubmitAttachmentsTooLargeResponse> | undefined;

    return body?.code === MAIL_ATTACHMENTS_TOO_LARGE_CODE ? body as CartSubmitAttachmentsTooLargeResponse : null;
};
